import React, { Fragment, useEffect, useState, useCallback,useRef } from "react";
import { useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import {
  ComboBox,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent,
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { DropDownList } from "@progress/kendo-react-dropdowns";


import { updateSearch, getSearchSelector } from "./SearchSlice";
import { useAppDispatch } from "../Core/store.hooks";

type handler = (params: any) => void;

interface IDeviceFilterProps {
  gridType: string;
}

const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    };
};


const Filters = (props: IDeviceFilterProps) => {
  const globalParams = useSelector(getSearchSelector);
    const dispatch = useAppDispatch();
    const [filters, updateFilters] = useState<any>(globalParams);
  const [countries, updateCountries] = useState<any[]>([]);

    const clearHandler = () => {
        dispatch(updateSearch({
            searchAll: "",
            country: "",
            customerID: "",
            projectNr: "",
            machineSerial: "",
            dataSource: "MPE , D365"
        }));
    }



        // Create a debounced function for dispatch
        const debouncedUpdate = useRef(
            debounce((newFilters: any) => {
                dispatch(updateSearch(newFilters));
            }, 300) // 300ms debounce delay
        );

        // Update Redux state with debounced dispatch
        useEffect(() => {
            debouncedUpdate.current(filters);
        }, [filters]);

        // Sync filters with globalParams
        useEffect(() => {
            if (JSON.stringify(filters) !== JSON.stringify(globalParams)) {
                updateFilters(globalParams);
            }
        }, [globalParams]);

        const handleInputChange = (key: string, value: string) => {
            updateFilters((prevFilters: any) => ({
                ...prevFilters,
                [key]: value,
            }));
        };


  //const comboBoxFilters = () => {
  //  return {
  //    countries: (event: ComboBoxFilterChangeEvent) => {
  //      updateCountries(
  //        filterBy(Format.Countries(deviceObjects), event.filter)
  //      );
  //    },

  //  };
  //};

  function renderContent() {
    if (props.gridType == "MPE Customer Assembly Devices") {
      return <div style={{ color: "#fff" }}>Use Grid column filters</div>;
    }

    return (
        <Fragment>
            <div>
                <div className="metricCombo">
                <Button className="pp-filter-button" onClick={() => clearHandler()}>
                    CLEAR ALL FILTERS
                    </Button>
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label">Search All</label>
                    <Input
                        value={filters.searchAll || ""}
                        onChange={(e) => handleInputChange("searchAll", e.target.value)}
                    />
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label" style={{ width: "300px" }}>
                        Machine Serial
                    </label>
                    <Input
                        value={filters.machineSerial || ""}
                        onChange={(e) => handleInputChange("machineSerial", e.target.value)}
                    />
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label" style={{ width: "300px" }}>
                        Project Number
                    </label>
                    <Input
                        value={filters.projectNr || ""}
                        onChange={(e) => handleInputChange("projectNr", e.target.value)}
                    />
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label">Country</label>
                    <Input
                        value={filters.country || ""}
                        onChange={(e) => handleInputChange("country", e.target.value)}
                    />
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label" style={{ width: "300px" }}>
                        Customer ID
                    </label>
                    <Input
                        value={filters.customerID || ""}
                        onChange={(e) => handleInputChange("customerID", e.target.value)}
                    />
                </div>
               
                <div className="k-textbox-container metricCombo">
                    <label className="k-label">Remote Gateway Type</label>
                    <DropDownList
                        data={[
                            "All",
                            "Secomea",
                            "Tosibox",
                            "Secomea or Tosibox",
                            "Secomea and Tosibox",
                            "None",
                        ]}
                        defaultValue={"All"}
                        value={filters.remoteGateway || "All"}
                        onChange={(e) =>
                            handleInputChange("remoteGateway", e.target.value as string)
                        }
                    />
                </div>
                {/*<div className="k-textbox-container metricCombo">*/}
                {/*    <label className="k-label">Data Sources</label>*/}
                {/*    <DropDownList*/}
                {/*        data={["All", "MPE , D365", "MPE", "D365", "Axapta Archive"]}*/}
                {/*        defaultValue={"MPE , D365"}*/}
                {/*        value={filters.dataSource || "MPE , D365"}*/}
                {/*        onChange={(e) =>*/}
                {/*            handleInputChange("dataSource", e.target.value as string)*/}
                {/*        }*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </Fragment>
    );
  }
  return <Fragment>{renderContent()}</Fragment>;
};

export default Filters;
